import {Box, Text, Image, SimpleGrid, ActionIcon} from "@mantine/core";
import {IconPlus} from "@tabler/icons-react";
import {decode} from "html-entities";

export default function _ProductByCategory4({component}) {
    return (
        <Box
            mx={component?.customize_styles?.general_decoration?.margin_x}
            my={component?.customize_styles?.general_decoration?.margin_y}
            px={component?.customize_styles?.general_decoration?.padding_x}
            py={component?.customize_styles?.general_decoration?.padding_y}
            bg={component?.customize_styles?.general_decoration?.background_color}
            bd={`${component?.customize_styles?.general_decoration?.border_width} solid ${component?.customize_styles?.general_decoration?.border_color}`}
            style={{
                borderRadius:`${component?.customize_styles?.general_decoration?.border_radius}px`,
                boxShadow: `${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px #00000014`,
            }}
        >
            <Text ff="Inter" fz={20} mb={10} fw={600}>
                {component?.customize_properties?.label}
            </Text>

            <SimpleGrid
                cols={component?.customize_styles?.grid_view_decoration?.column}
                spacing={component?.customize_styles?.grid_view_decoration?.row_gap}
                verticalSpacing={component?.customize_styles?.grid_view_decoration?.column_gap}
                mx={component?.customize_styles?.box_decoration?.margin_x}
                my={component?.customize_styles?.box_decoration?.margin_y}
            >
                {component?.items?.map((item) => (
                    <Box
                        key={item?.name}
                        pos="relative"
                        px={component?.customize_styles?.box_decoration?.padding_x}
                        py={component?.customize_styles?.box_decoration?.padding_y}
                        bg={component?.customize_styles?.box_decoration?.background_color}
                        bd={`${component?.customize_styles?.box_decoration?.border_width} solid ${component?.customize_styles?.box_decoration?.border_color}`}
                        style={{
                            borderRadius:`${component?.customize_styles?.box_decoration?.border_radius}px`,
                            boxShadow: `${component?.customize_styles?.box_decoration?.shadow_offset_x}px ${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px #00000014`,
                            overflow: "hidden",
                        }}
                    >
                        <Box
                            pos="relative"
                            mb={6}
                            ta={component?.customize_styles?.image_decoration?.alignment}
                        >
                            <Image
                                src={item?.image_url}
                                alt={item?.name}
                                radius={component?.customize_styles?.image_decoration?.radius}
                                fit={component?.customize_styles?.image_decoration?.boxfit}
                                w={component?.customize_styles?.image_decoration?.width}
                                height={component?.customize_styles?.image_decoration?.height}
                                display="inline-block"
                                maw={130}
                            />
                        </Box>

                        <Text
                            mb={18}
                            lineClamp={1}
                            fs={component?.customize_styles?.name_text_decoration?.font_style}
                            fw={component?.customize_styles?.name_text_decoration?.font_weight}
                            ff={component?.customize_styles?.name_text_decoration?.font_family}
                            c={component?.customize_styles?.name_text_decoration?.color}
                            lh={component?.customize_styles?.name_text_decoration?.text_height}
                            fz={component?.customize_styles?.name_text_decoration?.font_size}
                            ls={component?.customize_styles?.name_text_decoration?.letter_spacing}
                        >
                            {item?.name}
                        </Text>

                        <Text
                            fs={
                                component?.customize_styles?.product_price_text_decoration
                                    ?.font_style
                            }
                            fw={
                                component?.customize_styles?.product_price_text_decoration
                                    ?.font_weight
                            }
                            ff={
                                component?.customize_styles?.product_price_text_decoration
                                    ?.font_family
                            }
                            c={component?.customize_styles?.product_price_text_decoration?.color}
                            ta={
                                component?.customize_styles?.product_price_text_decoration
                                    ?.text_align
                            }
                            lh={
                                component?.customize_styles?.product_price_text_decoration
                                    ?.text_height
                            }
                            fz={
                                component?.customize_styles?.product_price_text_decoration
                                    ?.font_size
                            }
                            ls={
                                component?.customize_styles?.product_price_text_decoration
                                    ?.letter_spacing
                            }
                            style={{
                                textDecorationLine:
                                component?.customize_styles?.product_price_text_decoration
                                    ?.text_decoration,
                                textDecorationColor:
                                component?.customize_styles?.product_price_text_decoration
                                    ?.decoration_color,
                                textDecorationThickness:
                                component?.customize_styles?.product_price_text_decoration
                                    ?.decoration_thickness,
                            }}
                        >
                            {decode(item?.currency)} {item?.discount_price ? item.discount_price : item?.price}

                        </Text>
                        <Box pos="absolute" bottom={0} right={0}>
                            <ActionIcon
                                size="lg"
                                variant="filled"
                                color="#0D6EFD"
                                style={{
                                    borderTopLeftRadius: 15,
                                    borderBottomRightRadius: 15,
                                    borderTopRightRadius: 0,
                                    borderBottomLeftRadius: 0,
                                }}
                            >
                                <IconPlus style={{ width: "70%", height: "70%" }} stroke={2} />
                            </ActionIcon>
                        </Box>
                    </Box>
                ))}
            </SimpleGrid>
        </Box>
    );
}
